import { FormFieldSubmittingAuthor } from '@publishing-engine/domain/types/article';
import AuthorCard from './AuthorCard';
import { useFormContext } from 'react-hook-form';
import { ISubmissionFormData } from 'src/contexts/FormContext';
import { IAuthorWithEmail } from '@publishing-engine/domain/models';
import { AuthorEditModal } from './AuthorEditModal';
import { useState } from 'react';
import { IUser } from '@publishing-engine/domain/fixtures';

const SubmittingAuthor = ({
  config,
  submittingUser
}: {
  config: FormFieldSubmittingAuthor;
  submittingUser: IUser;
}) => {
  const { getValues, setValue, trigger } =
    useFormContext<ISubmissionFormData>();

  const {
    params: { labels }
  } = config;

  const authors = (getValues('metadata.authors') as IAuthorWithEmail[]) || [];
  const userEmail = getValues('submittingAuthor');
  const authorsWithSubmissionUser = [submittingUser, ...authors].filter(
    author => author.firstName && author.lastName
  );
  const user = authorsWithSubmissionUser.find(
    author => author.email === userEmail
  )!;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const handleSaveChanges = async (selectedEmail: string) => {
    setValue('submittingAuthor', selectedEmail);
    await trigger('submittingAuthor'); // Trigger validation and re-render

    setIsEditing(false);
  };

  const handleEditClick = (isEditing: boolean) => {
    if (isEditing) {
      setIsModalOpen(true);
    } else {
      setIsEditing(isEditing);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setIsEditing(false);
  };

  const handleModalConfirm = () => {
    setIsEditing(true);
    setIsModalOpen(false);
  };

  return (
    <>
      <AuthorCard
        title={labels.main}
        subtitle={labels.subtitle}
        isEditing={isEditing}
        showOrcid={true}
        user={user}
        options={authorsWithSubmissionUser.map(author => ({
          value: author.email,
          label: `${author.firstName} ${author.lastName}`
        }))}
        defaultValue={submittingUser.email}
        onChange={handleSaveChanges}
        onEdit={handleEditClick}
        disabled
        data-cy="author-card"
      />
      {isModalOpen && (
        <AuthorEditModal
          title="Edit Submitting Author?"
          description="This role manages important submission communications and commitments.
          Ensure consensus among all co-authors before making this change to
          avoid potential conflicts."
          onClose={handleModalClose}
          onConfirm={handleModalConfirm}
          data-cy="author-edit-modal"
        />
      )}
    </>
  );
};

export default SubmittingAuthor;
